import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';
import { createTabsComponent } from '@vfde-brix/tabs';

/**
 * Mount Tabs BRIX block to activate its funcionality on the content part
 */
const mountTabs = (wrapperId: string) => {
    const containerEl = document.getElementById(wrapperId) as HTMLElement;

    return containerEl && createTabsComponent(containerEl, NO_PATTERN_BUSINESS_LOGIC);
};

export default mountTabs;
